/// <amd-module name="Artifacts/Pypi/commands/Promote" />

import { PypiActions } from "Artifacts/Pypi/redux";
import { getPromoteCommandCreator } from "Artifacts/Root/protocols/Commands";

export const createPromoteCommand = getPromoteCommandCreator(PypiActions.promote);
